var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"member"}},[_c('div',{style:({backgroundImage: _vm.isCustomApply ? 'none' : ("url(" + _vm.urlBodyBg + ")"), backgroundColor: _vm.isCustomApply ? '#fff' : ''})},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }